import React, {useState, useEffect} from 'react'
import {Form} from "antd";

const OfferUpdateUnit = ({record}) => {
    const [unit, setUnit] = useState()

    useEffect(() => {
        if (record.stock) {
            setUnit(record.stock.unit)
        }
    }, [record])

    return(
        <React.Fragment>
            <Form>
                <Form.Item>
                    <span>{unit}</span>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateUnit